import * as actionTypes from '../actionTypes'
import api from '../api'

export const fetchNumbers = () => {
	return async (dispatch, getState) => {

		let total, skip, limit, inboundProgramNumbers
		inboundProgramNumbers = []
		skip = 0
		limit = 200

		do {
			let response = await api.service('inboundProgramNumbers').find(
				{
					query: {
						id: { $notIn: [206, 229, 300, 301, 263, 10000] }, // excluding Michelin ONCall, ESD, Fleetnet, etc.
						$limit: limit,
						$skip: skip,
						$include: ['type','assetTypes.assetValidation','vehicleTypes.vehicleType']
					}
				}
			)
			
			inboundProgramNumbers = inboundProgramNumbers.concat(response.data)
			total = response.total
			skip = skip + 200
		} while (total > skip)
		dispatch(fetchNumbersAction(inboundProgramNumbers))
	}
}

export const failNewInboundSave = (newInboundProgram) => ({
	type: actionTypes.BAD_INBOUND_SAVE,
	inboundProgram: newInboundProgram
})

export const fetchNumbersAction = (inboundProgramNumbers) => ({
	type: actionTypes.FETCH_NUMBERS,
	numbers: inboundProgramNumbers
})

export const closeMe = () => ({
	type: actionTypes.CLOSE_INBOUND
})

export const editCloseMe = () => ({
	type: actionTypes.CLOSE_EDIT_INBOUND
})

export const saveNewInbound = () => {
	return async (dispatch, getState) => {
		const state = getState()
		const newInboundProgram = state.inboundNumbers.newInboundProgram
		let fail = false
		newInboundProgram.customerNameErrorMessage = ''
		newInboundProgram.tollFreeNumberErrorMessage = ''
		newInboundProgram.billToErrorMessage = ''
		newInboundProgram.accountTypeIdErrorMessage = ''

		if (!newInboundProgram.customerName) {
			fail = true
			newInboundProgram.customerNameErrorMessage = "Must be populated"
		}
		if (!newInboundProgram.tollFreeNumber && !(newInboundProgram.tollFreeNumber.replace(/[() -]/gi, '').length === 11)) {
			fail = true
			newInboundProgram.tollFreeNumberErrorMessage = "Must be populated"
		}
		if (!newInboundProgram.accountTypeId) {
			fail = true
			newInboundProgram.accountTypeIdErrorMessage = "Must be populated"
		}
		if (fail) {
			dispatch(failEditInboundSave(newInboundProgram))
			return
		}

		await api.service('inboundProgramNumbers').create({
			customerName: newInboundProgram.customerName,
			tollFreeNumber: newInboundProgram.tollFreeNumber.replace(/[() -]/gi, ''),
			accountTypeId: newInboundProgram.accountTypeId,
			billTo: newInboundProgram.billTo,
			isDisabled: false
		})
		fetchNumbers()(dispatch)
	}
}

export const failEditInboundSave = (newInboundProgram) => ({
	type: actionTypes.BAD_INBOUND_EDIT_SAVE,
	inboundProgram: newInboundProgram
})

export const newOnChange = (event) => {
	return async (dispatch, getState) => {
		dispatch(newOnChangeAction(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value))
	}
}

export const newOnChangeAction = (field, value) => ({
	type: actionTypes.NEW_INBOUND_PROGRAM,
	value: value,
	field: field
})

export const newSelectOnChange = (event) => {
	return async (dispatch, getState) => {
		dispatch(newSelectOnChangeAction(event.target.name, event.target.value))
	}
}

export const newSelectOnChangeAction = (field, value) => ({
	type: actionTypes.NEW_SELECT_INBOUND_PROGRAM,
	value: value,
	field: field
})

export const openNewInbound = () => {
	return {
		type: actionTypes.ADD_INBOUND
	}
}

export const startingInboundSave = () => ({
	type: actionTypes.STARTING_INBOUND
})

export const closeEditInbound = () => ({
	type: actionTypes.CLOSE_EDIT
})

export const openEditInbound = (obj) => ({
	type: actionTypes.OPEN_EDIT,
	edit: obj
})

export const saveInboundEdit = () => {
	return async (dispatch, getState) => {
		const loadedProgram = getState().inboundNumbers.loadedProgram

		loadedProgram.customerNameErrorMessage = ''
		loadedProgram.tollFreeNumberErrorMessage = ''
		loadedProgram.billToErrorMessage = ''
		loadedProgram.accountTypeIdErrorMessage = ''

		let fail = false

		if (!loadedProgram.customerName) {
			fail = true
			loadedProgram.customerNameErrorMessage = "Must be populated"
		}
		if (!loadedProgram.tollFreeNumber || !(loadedProgram.tollFreeNumber.replace(/[() -]/gi, '').length === 10)) {
			fail = true
			loadedProgram.tollFreeNumberErrorMessage = "Must be populated and 10 digits"
		}
		if (!loadedProgram.accountTypeId) {
			fail = true
			loadedProgram.accountTypeIdErrorMessage = "Must be populated"
		}
		if (fail) {
			dispatch(failEditInboundSave(loadedProgram))
			return
		}

		await api.service('inboundProgramNumbers').patch(loadedProgram.id, {
			customerName: loadedProgram.customerName,
			tollFreeNumber: loadedProgram.tollFreeNumber.replace(/[() -]/gi, ''),
			accountTypeId: loadedProgram.accountTypeId,
			billTo: loadedProgram.billTo,
			shipTo:loadedProgram.shipTo,
			isDisabled: loadedProgram.isDisabled
		})
		fetchNumbers()(dispatch)
	}
}

export const saveInboundEditAction = () => ({
	type: actionTypes.SAVE_INBOUND_EDIT
})

export const editOnChange = (event) => {
	return async (dispatch, getState) => {
		dispatch(editOnChangeAction(event.target.name, event.target.value))
	}
}

export const editOnChangeAction = (field, value) => ({
	type: actionTypes.EDIT_INBOUND_PROGRAM,
	value: value,
	field: field
})

export const loadShipTo = (shipTo) => ({
	type: actionTypes.LOAD_SHIP_TO,
	shipTo: shipTo
})

const getShipTos = async (state, city, billTo) => {
	let billToResp = await api.service('fleetLocations').find({
		query: {
			accountNumber: { $eq: billTo }
		}
	})
	if (billToResp.data.length < 1)
		return []
	let resp = await api.service('fleetLocations').find({
		query: {
			parentId: { $eq: billToResp.data[0].id },
			isShipTo: true,
			$include: ['address'],
			$limit: 200,
		}
	})
	let shipTos = resp.data.filter(f => (city ? f.address.city.toUpperCase().includes(city.toUpperCase()) : true) &&
		(state ? f.address.state === state : true))

	return shipTos
}

export const startShipToSearch = () => {
	return async (dispatch, getState) => {
		const state = getState()
		const billTo = state.inboundNumbers.loadedProgram.billTo
		if (!billTo) {
			return
		}
		let shipTos = await getShipTos('', '', billTo)
		dispatch(shipSearchStartAction(shipTos))
	}
}

export const shipSearchStartAction = (shipTos) => ({
	type: actionTypes.START_SEARCH_SHIP_ACTION,
	shipTos: shipTos
})

export const shipToSearchChange = (event) => {
	return async (dispatch, getState) => {
		const newValue = event.target.value
		const eventName = event.target.name
		let shipTos = null
		const state = getState() 
		if (eventName === 'City') {
			shipTos = await getShipTos(state.inboundNumbers.shipToSearchState, newValue, state.inboundNumbers.loadedProgram.billTo)
			dispatch(shipToSearchChangeAction(eventName, newValue, shipTos))
		} else {
			shipTos = await getShipTos(newValue, state.inboundNumbers.shipToSearchCity, state.inboundNumbers.loadedProgram.billTo)
			dispatch(shipToSearchChangeAction(eventName, newValue, shipTos))
		}
	}
}

export const shipToSearchChangeAction = (field, value, shipTos) => ({
	type: actionTypes.SHIP_TO_SEARCH_CHANGE_ACTION,
	value: value,
	field: field,
	shipTos: shipTos
})

export const editSelectOnChange = (event) => {
	return async (dispatch, getState) => {
		dispatch(editSelectOnChangeAction(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value))
	}
}

export const editSelectOnChangeAction = (field, value) => ({
	type: actionTypes.EDIT_SELECT_INBOUND_PROGRAM,
	value: value,
	field: field
})

export const newOnChangeCustomerName = (event) => {
	return async (dispatch, getState) => {
		const val = event.target.value
		const name = event.target.name
		dispatch(newOnChangeAction(name, val))

		if (event.target.value.length > 2) {
			const state = getState()
			find(event.target.value, state.homePage.inboundProgramAccountTypes).then(x => {
				dispatch(newOnChangeCustomerNameAction(x))
			})
		}

	}
}

export const newOnChangeCustomerNameAction = (possible) => ({
	type: actionTypes.NEW_CHANGE_CUSTOMER_NAME,
	possible: possible
})

const find = async (name, dropdown) => {
	let response = []
	let fleetResponse = await api.service('fleetLocations').find({
		query: {
			name: { $iLike: '%' + name + '%' },
			isBillTo: true,
			$limit: 200,
		}
	})
	const fleetId = dropdown.filter(x => x.name === "Fleet")[0].id
	const dealerId = dropdown.filter(x => x.name === "Dealer")[0].id
	const fleets = fleetResponse.data.map(f => {
		return {
			customerName: f.name,
			billTo: f.accountNumber,
			accountTypeId: fleetId,
			accountTypeName: "Fleet"
		}
	})
	response = response.concat(fleets)
	let dealerResponse = await api.service('localAccounts').find({
		query: {
			name: { $iLike: '%' + name + '%' },
			$limit: 200,
		}
	})
	const dealers = dealerResponse.data.map(d => {
		return {
			customerName: d.name,
			billTo: d.accountNumber,
			accountTypeId: dealerId,
			accountTypeName: "Dealer"
		}
	})
	response = response.concat(dealers)
	return response
}

export const loadCustomer = (customerName, billTo, accountTypeId) => ({
	type: actionTypes.LOAD_NEW_CUSTOMER,
	name: customerName,
	billTo: billTo,
	account: accountTypeId
})


// WEBPACK FOOTER //
// ./src/actions/inboundProgram.js